import { render, staticRenderFns } from "./DeviceTemplate.vue?vue&type=template&id=a2b516d0&scoped=true"
import script from "./DeviceTemplate.vue?vue&type=script&lang=js"
export * from "./DeviceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b516d0",
  null
  
)

export default component.exports